export default {
    namespaced: true,
    state: {
        token: '',
    },
    getters: {
        // 获取token
        get_token: state => {
          return state.token
        },
    },
    mutations: {
        // 保存登陆token
        save_token (state, token) {
            state.token = token
            localStorage.setItem('temporary_token', token)
        },
        
        // 清除vuex数据，以及本地存储数据
        clear (state) {
          state.token = ''

          localStorage.setItem('token', state.token)
        },
    },
    actions: {
        
    }
}
